export class OrganisationFeedback {
    constructor(public userName: string, public email: string, public feedbackType: number, public feedbackText: string, public response: boolean, public responseText: string) {

    }
}